import Preferences from './Preferences.page';

export default Preferences;